import React from 'react'
import cx from 'classnames'
import {
  useIsTrackSwitchedOff,
  usePublications,
  useScreenShareParticipant,
  useTrack,
  useMediaContext,
  useParticipantIsReconnecting,
  useIsTrackEnabled
} from '@gopeerproject/web-kit'

import { User, Loader, Icon } from '@components/UI'

import NetworkQualityLevel from './NetworkQualityLevel'
import { useClassroomQuery } from '../../../hooks'

const MainParticipantInfo = ({ participant, minimized, children }) => {
  const { room } = useMediaContext()
  const localParticipant = room?.localParticipant
  const { data } = useClassroomQuery()
  const { image, name } = {
    image: data?.participants[participant?.identity]?.image,
    name: data?.participants[participant?.identity]?.name
  }

  const screenShareParticipant = useScreenShareParticipant()
  const isRemoteParticipantScreenSharing =
    screenShareParticipant && screenShareParticipant !== localParticipant

  const publications = usePublications(participant)
  const videoPublication = publications.find((p) =>
    p.trackName.includes('camera')
  )
  const screenSharePublication = publications.find((p) =>
    p.trackName.includes('screen')
  )

  const videoTrack = useTrack(screenSharePublication || videoPublication)
  const isVideoEnabled = !!videoTrack

  const audioPublication = publications.find((p) => p.kind === 'audio')
  const audioTrack = useTrack(audioPublication)
  const isAudioTrackEnabled = useIsTrackEnabled(audioTrack)

  const isVideoSwitchedOff = useIsTrackSwitchedOff(videoTrack)
  const isParticipantReconnecting = useParticipantIsReconnecting(participant)

  return (
    <div
      className={cx('gp-Media-mainParticipantInfo', {
        'is-videoOff':
          (!isVideoEnabled || isVideoSwitchedOff) &&
          !isRemoteParticipantScreenSharing
      })}
    >
      <div className='gp-Media-mainParticipantInfo-video'>
        {children}
        {(!isVideoEnabled || isVideoSwitchedOff) &&
          !isRemoteParticipantScreenSharing && (
            <User
              name={name}
              img={image}
              hideName
              size={minimized ? 'larger' : 'gigantic'}
            />
          )}
        {isParticipantReconnecting && <Loader icon full withBackground />}
      </div>

      {(minimized || !screenShareParticipant) && (
        <div className='gp-Media-mainParticipantInfo-info'>
          <div>
            {isAudioTrackEnabled ? (
              <Icon name='microphone' />
            ) : (
              <Icon name='microphone off' />
            )}
          </div>
          {!!screenSharePublication && (
            <div>
              <Icon name='screen' />
            </div>
          )}
          <NetworkQualityLevel participant={participant} />
        </div>
      )}
    </div>
  )
}

export default MainParticipantInfo
